import PropTypes from 'prop-types';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import {
  getAnalyticsPaletteColor,
  getAnalyticsSeriesColors,
  getSemanticSeriesColor,
  withAlpha,
} from './analyticsColors';

ChartJS.register(ArcElement, Tooltip, Legend);

const getBackgroundHexColorWithReducedOpacity = (backgroundHexColor) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(backgroundHexColor);
  return result
    ? `rgba(${Number.parseInt(result[1], 16)}, ${Number.parseInt(result[2], 16)}, ${Number.parseInt(
        result[3],
        16
      )}, 0.24)`
    : null;
};

export function DoughnutChart({ chartData, title, showTitle = true, paletteVariant = 'default' }) {
  //const data = processData(chartData)//setChartData(chartData);
  const defaultBackgroundColors = Array.from(
    { length: 10 },
    (_, index) => getAnalyticsSeriesColors(index, { variant: paletteVariant }).background
  );
  const defaultBorderColors = Array.from({ length: 10 }, (_, index) =>
    getAnalyticsPaletteColor(index, { variant: paletteVariant })
  );

  const data = {
    labels: chartData[0].labels,
    datasets: [
      {
        data: chartData[0].values,
        backgroundColor: chartData[0].labels?.map((label, index) => {
          const semanticColor = getSemanticSeriesColor(label);
          if (semanticColor) {
            return withAlpha(semanticColor, 0.24);
          }

          return chartData[0].labelToColorMapping[label]
            ? getBackgroundHexColorWithReducedOpacity(chartData[0].labelToColorMapping[label]) ??
                chartData[0].labelToColorMapping[label]
            : defaultBackgroundColors[index % defaultBackgroundColors.length];
        }),
        borderColor: chartData[0].labels?.map((label, index) => {
          const semanticColor = getSemanticSeriesColor(label);
          if (semanticColor) {
            return semanticColor;
          }

          return chartData[0].labelToColorMapping[label]
            ? chartData[0].labelToColorMapping[label]
            : defaultBorderColors[index % defaultBorderColors.length];
        }),
        borderWidth: 1,
        hoverBackgroundColor: chartData[0].labels?.map((label, index) => {
          const semanticColor = getSemanticSeriesColor(label);
          const base =
            semanticColor ||
            chartData[0].labelToColorMapping[label] ||
            defaultBorderColors[index % defaultBorderColors.length];
          return withAlpha(base, 0.44);
        }),
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: showTitle,
        text: `${title}`,
      },
    },
    maintainAspectRatio: false,
  };

  return <Doughnut options={options} data={data} />;
}

DoughnutChart.propTypes = {
  chartData: PropTypes.array.isRequired,
  title: PropTypes.string,
  showTitle: PropTypes.bool,
  paletteVariant: PropTypes.string,
};
